import { render, staticRenderFns } from "./batchCredit.vue?vue&type=template&id=c3a04b18&scoped=true&"
import script from "./batchCredit.vue?vue&type=script&lang=js&"
export * from "./batchCredit.vue?vue&type=script&lang=js&"
import style0 from "./batchCredit.vue?vue&type=style&index=0&id=c3a04b18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a04b18",
  null
  
)

export default component.exports